import type { IconSvgObject } from './types';

const MousePointer01Icon: IconSvgObject = [
  ["path", { d: "M9.79495 4.62973L15.8285 6.99069C19.3085 8.35243 21.0485 9.03329 20.9908 10.1133C20.9331 11.1934 19.1172 11.6886 15.4855 12.6791C14.4041 12.974 13.8634 13.1215 13.4885 13.4963C13.1137 13.8712 12.9662 14.4119 12.6713 15.4933C11.6808 19.125 11.1855 20.9409 10.1055 20.9986C9.02548 21.0563 8.34461 19.3163 6.98288 15.8363L4.62192 9.80276C3.19624 6.15934 2.48339 4.33764 3.40661 3.41442C4.32982 2.49121 6.15153 3.20405 9.79495 4.62973Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default MousePointer01Icon;
